
import { makeStyles } from "@material-ui/core";
import { Typography, Avatar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
// import VisibilityIcon from '@mui/icons-material/Visibility';
import { useLocation, useNavigate } from "react-router-dom";
import StatusEstabelecimento from "../../../../utils/status/statusEstabelecimento";
import ListaVazia from "../../../../utils/listaVazia";
import DateHora from "../../../../utils/dateHora";
import TempoPassado from "../../../../utils/tempoPassado";
import StatusEntrada from "../../../../utils/status/statusEntrada";
import { Paper } from "@mui/material";


const useStyles = makeStyles((theme) => ({
    hover: { '&:hover': { backgroundColor: '#85287d8a' }, cursor: 'pointer' }
}))

export default function ListaSolicitacao({ estabelecimentos, children }) {
    const classes = useStyles()
    const navigate = useNavigate()
    const location = useLocation();

    const isReprovadasPage = location.pathname === '/admin/solicitacoes/reprovadas';

    return (
        <TableContainer sx={{ border: "1px black" }} component={Paper}>
            <Table sx={{ border: "1px", borderColor: "black" }}>
                <TableHead sx={{ backgroundColor: "#dcdede" }}>
                    <TableRow>
                        <TableCell ><Typography noWrap> <strong>Imagem</strong></Typography></TableCell>
                        <TableCell ><Typography noWrap> <strong>Nome</strong></Typography></TableCell>
                        <TableCell ><Typography noWrap> <strong>Tipo</strong></Typography></TableCell>
                        <TableCell ><Typography noWrap> <strong>Nº de entrada</strong></Typography></TableCell>
                        {/* <TableCell ><Typography noWrap> <strong>Número de Processo</strong></Typography></TableCell> */}
                        <TableCell ><Typography noWrap> <strong>Director técnico</strong></Typography></TableCell>
                        <TableCell ><Typography noWrap> <strong>Provincia</strong></Typography></TableCell>
                        <TableCell ><Typography noWrap> <strong>Solicitação</strong></Typography></TableCell>
                        <TableCell ><Typography noWrap> <strong>Estado</strong></Typography></TableCell>
                        <TableCell ><Typography noWrap> {isReprovadasPage ? <strong>Data de reprovação</strong> : <strong>Data de inscrição</strong>}</Typography></TableCell>
                        <TableCell ><Typography noWrap> <strong>Ultima intervenção</strong></Typography></TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {estabelecimentos.map((estabelecimento) => (

                        <TableRow key={estabelecimento?._id} className={classes.hover} onClick={() => navigate(`/admin/analise/solicitacao-de-licenciamento/${estabelecimento?._id}`)} title={estabelecimento?.nome}>

                            <TableCell component="th" scope="row">
                                <Avatar variant="square" src={estabelecimento?.logo} alt={estabelecimento?.nome} />
                            </TableCell>

                            <TableCell >{estabelecimento?.nome}</TableCell>
                            <TableCell >{estabelecimento?.tipo?.designacao}</TableCell>
                            <TableCell >{estabelecimento?.numeroEntrada}</TableCell>
                            {/* <TableCell >{estabelecimento?.numeroProcesso}</TableCell> */}
                            <TableCell >{estabelecimento?.directorTecnico?.dadosPessoais?.nome}</TableCell>
                            <TableCell >{estabelecimento?.provincia}</TableCell>
                            <TableCell ><StatusEntrada status={estabelecimento?.tipoEntrada} />  </TableCell>
                            <TableCell >  <StatusEstabelecimento status={estabelecimento?.status} /></TableCell>
                            <TableCell ><DateHora date={isReprovadasPage ? estabelecimento?.dataDespacho : estabelecimento?.createdAt} /> </TableCell>
                            <TableCell ><TempoPassado date={estabelecimento?.updatedAt} /> </TableCell>
                            {/* <TableCell > <Typography noWrap> {estabelecimento?.email}</Typography></TableCell> */}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

            {estabelecimentos.length < 1 && <ListaVazia text={'DE MOMENTO NÃO HÁ SOLICITACÕES PARA O SEU PERFIL INTERVIR'} />}

            {children}
        </TableContainer>
    )
}
